var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("CostSubtotalEditor", {
        attrs: { viewModel: _vm.costSubtotalEditor },
        on: {
          "create-subtotal": _vm.handleCreateCostSubtotalCommand,
          "rename-subtotal": _vm.handleRenameCostSubtotalCommand,
        },
      }),
      _vm._v(" "),
      _c("ExpenseAccountEditor", {
        attrs: { viewModel: _vm.expenseAccountEditor },
        on: {
          "create-expense": _vm.handleCreateExpenseAccountCommand,
          "update-cost": _vm.hanldeUpdateCostAccountCommand,
        },
      }),
      _vm._v(" "),
      _c("CorporateNavigation", { attrs: { ActivePage: "strategy" } }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "container",
          staticStyle: { "margin-top": "80px", "padding-top": "40px" },
        },
        [
          _c("div", { staticClass: "row" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "col-lg-6 text-right align-self-end" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-outline-secondary",
                  staticStyle: { padding: "0.7em 2em" },
                  attrs: { role: "button" },
                  on: {
                    click: function ($event) {
                      return _vm.showSubtotalCreator()
                    },
                  },
                },
                [_vm._v("Create subtotal")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-success",
                  staticStyle: { padding: "0.7em 2em" },
                  attrs: { role: "button" },
                  on: {
                    click: function ($event) {
                      return _vm.showExpenseCreator(null)
                    },
                  },
                },
                [_vm._v("Create expense")]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("hr", {
            staticStyle: { "border-color": "#bbb", margin: "20px 0 60px" },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "mt-3" }, [
            _c(
              "table",
              { staticClass: "table table-bordered table-hover" },
              [
                _vm._m(1),
                _vm._v(" "),
                _c(
                  "tbody",
                  _vm._l(_vm.standaloneCosts, function (cost) {
                    return _c("tr", { key: cost.Id }, [
                      _c("td", [
                        _c("strong", [_vm._v(_vm._s(cost.Name))]),
                        _c("br"),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "\n                            " +
                            _vm._s(cost.AccountType) +
                            "\n                        "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "\n                            " +
                            _vm._s(cost.Classification) +
                            "\n                        "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("div", { staticClass: "dropdown" }, [
                          _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-outline-secondary dropdown-toggle",
                              attrs: {
                                type: "button",
                                "data-toggle": "dropdown",
                              },
                            },
                            [
                              _vm._v(
                                "\n                                    Actions\n                                "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "dropdown-menu dropdown-menu-right",
                            },
                            [
                              _c(
                                "a",
                                {
                                  staticClass: "dropdown-item",
                                  on: {
                                    click: function ($event) {
                                      return _vm.showExpenseEditor(cost)
                                    },
                                  },
                                },
                                [_vm._v("Edit")]
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass: "dropdown-item",
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleDeleteExpenseAccountCommand(
                                        cost
                                      )
                                    },
                                  },
                                },
                                [_vm._v("Delete")]
                              ),
                            ]
                          ),
                        ]),
                      ]),
                    ])
                  }),
                  0
                ),
                _vm._v(" "),
                _vm._l(_vm.subtotals, function (sub) {
                  return _c(
                    "tbody",
                    { key: sub.Id },
                    [
                      _c("tr", [
                        _c("td", { attrs: { colspan: "3" } }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(sub.Name) +
                              "\n                        "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c("div", { staticClass: "dropdown" }, [
                            _c(
                              "button",
                              {
                                staticClass:
                                  "btn btn-outline-secondary dropdown-toggle",
                                attrs: {
                                  type: "button",
                                  "data-toggle": "dropdown",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                                    Actions\n                                "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "dropdown-menu dropdown-menu-right",
                              },
                              [
                                _c(
                                  "a",
                                  {
                                    staticClass: "dropdown-item",
                                    on: {
                                      click: function ($event) {
                                        return _vm.showSubtotalEditor(sub)
                                      },
                                    },
                                  },
                                  [_vm._v("Edit")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticClass: "dropdown-item",
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleDeleteCostSubtotalCommand(
                                          sub
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("Delete")]
                                ),
                              ]
                            ),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _vm._l(sub.Costs, function (cost) {
                        return _c("tr", { key: cost.Id }, [
                          _c("td", [
                            _c("strong", [_vm._v(_vm._s(cost.Name))]),
                            _c("br"),
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              "\n                            " +
                                _vm._s(cost.AccountType) +
                                "\n                        "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              "\n                            " +
                                _vm._s(cost.Classification) +
                                "\n                        "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _c("div", { staticClass: "dropdown" }, [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-outline-secondary dropdown-toggle",
                                  attrs: {
                                    type: "button",
                                    "data-toggle": "dropdown",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                                    Actions\n                                "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "dropdown-menu dropdown-menu-right",
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "dropdown-item",
                                      on: {
                                        click: function ($event) {
                                          return _vm.showExpenseEditor(cost)
                                        },
                                      },
                                    },
                                    [_vm._v("Edit")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "a",
                                    {
                                      staticClass: "dropdown-item",
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleDeleteExpenseAccountCommand(
                                            cost
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("Delete")]
                                  ),
                                ]
                              ),
                            ]),
                          ]),
                        ])
                      }),
                    ],
                    2
                  )
                }),
              ],
              2
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "col-lg-6" }, [
      _c(
        "h1",
        {
          staticStyle: {
            "font-size": "2em",
            "font-weight": "300",
            color: "#33475b",
            margin: "0",
          },
        },
        [_vm._v("Costs")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", { staticStyle: { width: "120px" } }),
        _vm._v(" "),
        _c("th", { staticStyle: { width: "120px" } }),
        _vm._v(" "),
        _c("th", { staticStyle: { width: "120px" } }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }